import { Event } from "./EventSource";
import { ICalendarEvent } from "./ICalendarEvent";
import { ICalendarEventCenter } from "./ICalendarEventCenter";

/** A container monitoring the status of ongoing calendar events. */
class CalendarEventHub {
  /** The current state of the known calendar events. */
  readonly events: Event<ICalendarEventCenter, ICalendarEvent>[];

  constructor(value: Event<ICalendarEventCenter, ICalendarEvent>[]) {
    this.events = value.map(c => CalendarEventHub.getParsedEvent(c));
  }

  private static getParsedEvent = (
    c: Event<ICalendarEventCenter, ICalendarEvent>
  ): Event<ICalendarEventCenter, ICalendarEvent> => new Event(c.key, c.custom, c.body ? c.body : null);

  /** Update the hub with the new state of the topic payloads. Ignores change if no topic has a more recent
   * payload tha is already held.
   */
  readonly update = (value: Event<ICalendarEventCenter, ICalendarEvent>[]): CalendarEventHub => {
    return new CalendarEventHub(value);
  };
}

export default CalendarEventHub;
